import { toast } from "react-toastify";
import axios from "../../customAxios";
import {
  VOUCHER_LIST_REQUEST,
  VOUCHER_LIST_SUCCESS,
  VOUCHER_LIST_FAIL,
  VOUCHER_UPDATE_STATUS,
} from "../constants/voucherConstants";

export const listVouchers = (page = 1, limit = 10, search = "", status = "") => async (dispatch) => {
  try {
    dispatch({ type: VOUCHER_LIST_REQUEST });

    const { data } = await axios.get(`/api/v1/admin/vouchers?page=${page}&limit=${limit}&search=${search}&status=${status}`);

    dispatch({
      type: VOUCHER_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: VOUCHER_LIST_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};


export const updateVoucherStatus = (voucherId, request) => async (dispatch) => {
  try {
      const { data } = await axios.put(`/api/v1/admin/updateVoucher/${voucherId}`, request);

      dispatch({
          type: VOUCHER_UPDATE_STATUS,
          payload: data,
      });
      toast.success(data.message);
  } catch (error) {
      console.error("Error updating voucher status:", error);
      toast.error(error);
      throw error;
  }
};
